import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'jalali-moment'


const AnnouncementList = ({icon, Title, description, date, alias, topImage}) => {
    
    
    return (  

        <div className="icon-box-item" >
            <div className="icon-box__icon">
                <img src={process.env.REACT_APP_BASE_URL + icon} alt='AnnouncementIcon'/>
            </div>
            <div className="icon-box__info">
            <Link to={'/announcement'+ `/${alias}`}>
                <h5>{Title}</h5>
            </Link>
              
                <p><i className='fa fa-calculator'/>{'  '}{moment(date, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</p>
            </div>
        </div>

    );
}
 
export default AnnouncementList;